/** Employee seat with team lead / global admin (and related roles): My / Team LHS submenu. */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();export function getShowPersonalTeamNavSubmenu(params: {
  isEmployer: boolean;
  isContractorViewer: boolean;
  isTeamsGlobalAdmin: boolean;
  hasTeamLeadOrAdminOnTeam: boolean;
}): boolean {
  const { isEmployer, isContractorViewer, isTeamsGlobalAdmin, hasTeamLeadOrAdminOnTeam } = params;

  return !isContractorViewer && (isTeamsGlobalAdmin || (!isEmployer && hasTeamLeadOrAdminOnTeam));
}

/** @deprecated Use {@link getShowPersonalTeamNavSubmenu}. */
export const getShowAbsenceNavSubmenu = getShowPersonalTeamNavSubmenu;

/** Expenses LHS: My expenses / Team expenses (same eligibility as absences). */
export const getShowExpenseNavSubmenu = getShowPersonalTeamNavSubmenu;
